"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canoeCheckWarningBreakedRules = exports.canoeEquipementOf = exports.bestEquipmentsForPeople = void 0;
const countBookingPeople_1 = require("../countBookingPeople");
const bestEquipmentsForPeople = (prices, people, relax = false, minAutonomousPeopleForUnderSeven = 0, maxChildrenWithMonitor = 1000, childrenWithMonitor = 0, errorThrowInTranslateCode = false) => {
    const childrenCount = countBookingPeople_1.countBookingChildren(prices, people);
    const childrenUnderSevenCount = countBookingPeople_1.countBookingChildrenUnderSeven(prices, people);
    const adultsCount = countBookingPeople_1.countBookingPeople(people) - childrenCount - childrenUnderSevenCount;
    const adultsRequiredForChildren = childrenCount * 2;
    if (childrenWithMonitor + childrenUnderSevenCount > maxChildrenWithMonitor) {
        throw new Error(errorThrowInTranslateCode === true ?
            'underSevenPlacesOverflow' :
            'Le nombre maximum de places -7ans avec le moniteur pour ce créneau est dépassé');
    }
    if ((adultsCount + childrenCount) < (minAutonomousPeopleForUnderSeven * childrenUnderSevenCount)) {
        if (relax) {
            return {
                type: 'canoe',
                customized: false,
                k1: 0,
                c2: 0,
                c3: 0,
            };
        }
        throw new Error(errorThrowInTranslateCode === true ?
            'minAutonomousPeopleNotReached' :
            (minAutonomousPeopleForUnderSeven * childrenUnderSevenCount) + ' personnes autonomes sont nécessaires pour transporter ' + childrenUnderSevenCount + ' enfant(s) avec le moniteur');
    }
    if (adultsCount < adultsRequiredForChildren) {
        if (relax) {
            return {
                type: 'canoe',
                customized: false,
                k1: 0,
                c2: 0,
                c3: 0,
            };
        }
        throw new Error(errorThrowInTranslateCode === true ?
            'twoAdultsRequiredForThirdPlaceChild' :
            'Deux adultes sont nécessaires pour transporter un enfant comme troisième place');
    }
    const adultsNotWithChildren = adultsCount - adultsRequiredForChildren;
    const c3 = childrenCount;
    const c2 = Math.floor(adultsNotWithChildren / 2);
    const k1 = Math.floor(adultsNotWithChildren - c2 * 2);
    return {
        type: 'canoe',
        customized: false,
        k1: k1,
        c2: c2,
        c3: c3,
    };
};
exports.bestEquipmentsForPeople = bestEquipmentsForPeople;
function canoeEquipementOf(label, options) {
    if (!(options === null || options === void 0 ? void 0 : options.equipments) ||
        options.equipments.type !== 'canoe' ||
        !options.equipments[label]) {
        return '';
    }
    return options.equipments[label];
}
exports.canoeEquipementOf = canoeEquipementOf;
function canoeCheckWarningBreakedRules(prices, people, minAutonomousPeopleForUnderSeven = 0) {
    const childrenCount = countBookingPeople_1.countBookingChildren(prices, people);
    const childrenUnderSevenCount = countBookingPeople_1.countBookingChildrenUnderSeven(prices, people);
    const adultsCount = countBookingPeople_1.countBookingPeople(people) - childrenCount - childrenUnderSevenCount;
    let breakedRules = [];
    if ((adultsCount + childrenCount) < (minAutonomousPeopleForUnderSeven * childrenUnderSevenCount)) {
        breakedRules.push((minAutonomousPeopleForUnderSeven * childrenUnderSevenCount) +
            ' personnes autonomes sont nécessaires pour transporter ' +
            childrenUnderSevenCount +
            ' enfant(s) avec le moniteur');
    }
    return breakedRules;
}
exports.canoeCheckWarningBreakedRules = canoeCheckWarningBreakedRules;
//# sourceMappingURL=canoe.js.map